import { useState } from "react";
import { Check, Copy } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Label } from "@/components/ui/label";
import { copyText } from "../../../shared/clipboard";

/** Surface for showing the one-time invite link with a Copy button. */
export function InviteLinkBox({ link }: { link: string }) {
  const [copied, setCopied] = useState(false);

  async function onCopy() {
    // Falls back to execCommand on plain-HTTP origins; the field is select-all if both paths fail.
    if (await copyText(link)) {
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    }
  }

  return (
    <div className="space-y-2 rounded-md border border-input bg-muted/40 p-4">
      <Label>Link kích hoạt — chia sẻ một lần</Label>
      <div className="flex flex-col gap-2 sm:flex-row sm:items-center">
        <code className="min-w-0 flex-1 select-all overflow-x-auto whitespace-nowrap rounded-md border border-input bg-background px-3 py-2 font-mono text-sm text-foreground">
          {link}
        </code>
        <Button type="button" onClick={onCopy} className="shrink-0">
          {copied ? (
            <>
              <Check aria-hidden="true" /> Đã copy
            </>
          ) : (
            <>
              <Copy aria-hidden="true" /> Copy link
            </>
          )}
        </Button>
      </div>
      <p className="text-sm text-muted-foreground">
        Hệ thống không lưu lại link sau khi rời trang. Hãy gửi qua Zalo / SMS / email
        cho nhân viên ngay. Link có hiệu lực 7 ngày.
      </p>
    </div>
  );
}
